import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'wilhelm_boellhoff_group',
    featureFlags: {
        assistanceEmailThreads: true,
    },
} satisfies IModuleProps;
